const Index = () => import('./index.vue');
const CreatePage = () => import('./_pages/create.vue');

export default [
    {
        path: '/customer-requests',
        name: 'ClientRequestsPage',
        component: Index
    },
    {
        path: '/new-request',
        name: 'NewRequestPage',
        component: CreatePage
    }
]